function copy_now_url_clipboard() {
  myURL = encodeURI(window.location.href);
  navigator.clipboard.writeText(myURL);
  alert('コピーしました : ' + myURL);
}

// SPアコーディオン
if (window.matchMedia('(max-width: 750px)').matches) {
  $('.g_menu_body-wrap .wedding-movie-title').on('click', function () {
    $(this).next().slideToggle();
    $(this).toggleClass('active');
  });
}

// 情熱大陸シリーズボタン
$('.aijouseries_toggle_wrap .toggle_btn').on('click', function () {
  $(this).next().slideToggle();
  $(this).toggleClass('active');
});

// モーダルウィンドウの制御
document.addEventListener('DOMContentLoaded', function () {
  const modalToggles = document.querySelectorAll('.modal-toggle');

  modalToggles.forEach(function (toggle) {
    const modal = toggle.nextElementSibling.nextElementSibling; // .modal要素

    // モーダルの背景部分をクリックした時の処理
    modal.addEventListener('click', function (e) {
      // モーダルコンテンツ部分（.modal-content）をクリックした場合は何もしない
      if (e.target.closest('.modal-content')) {
        return;
      }

      // 背景部分をクリックした場合はモーダルを閉じる
      toggle.checked = false;
    });
  });
});
// 画像名切り替え
$(function () {
  const $setElem = $('.switch'),
    pcName = '_pc',
    tbName = '_sp',
    replaceWidth = 750;

  $setElem.each(function () {
    const $this = $(this);
    function imgSize() {
      if (window.innerWidth > replaceWidth) {
        $this
          .attr('src', $this.attr('src').replace(tbName, pcName))
          .css({ visibility: 'visible' });
      } else {
        $this
          .attr('src', $this.attr('src').replace(pcName, tbName))
          .css({ visibility: 'visible' });
      }
    }
    $(window).resize(function () {
      imgSize();
    });
    imgSize();
  });
});

// header
var _window = $(window),
  headerChange = $('.header_sp_fixed'),
  heroBottom;

_window.on('scroll', function () {
  heroBottom = $('#mainvisual').height();
  if (_window.scrollTop() > heroBottom) {
    headerChange.addClass('show');
  } else {
    headerChange.removeClass('show');
  }
});

_window.trigger('scroll');

// スクロールヒント
new ScrollHint('#js-scroll', {
  suggestiveShadow: true,
  i18n: {
      scrollable: 'スクロールできます'
  }
});